import { FC } from 'react';
import { InnerIconProps, withIcon } from '@tempusfinance/common-ui';

const BoostArrowComponent: FC<InnerIconProps> = ({ size }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="nostra__icon nostra__icon__boostArrow"
      width={size}
      height={size}
      viewBox="0 0 12 12"
      fill="none"
    >
      <g clipPath="url(#clip0_2647_724)">
        <path
          d="M6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12Z"
          fill="#182B55"
        />
        <path
          d="M8.66659 6.00016L5.99992 3.3335L3.33325 6.00016"
          stroke="#F8F9FF"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M6 8.66683V3.3335" stroke="#F8F9FF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_2647_724">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const BoostArrow = withIcon(BoostArrowComponent);
